import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'

dayjs.locale(ja)

export const today = dayjs().format('YYYY年M月D日(ddd)')
export const thisYear = dayjs().year()
export const thisMonth = dayjs().month()
